import { Input as AntInput } from 'antd';
import { memo } from 'react';

const FieldWrapper = ({
  label,
  required,
  error,
  touched,
  helperText,
  className = '',
  children,
}) => (
  <div className={`mb-4 ${className}`}>
    {label && (
      <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
        {label}
        {required && <span className="ml-1 text-error">*</span>}
      </label>
    )}
    {children}
    {touched && error && <p className="mt-1 text-xs text-error sm:text-sm">{error}</p>}
    {!error && helperText && (
      <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{helperText}</p>
    )}
  </div>
);

const getStatus = (touched, error) => (touched && error ? 'error' : '');

export const Input = memo(
  ({
    label,
    required,
    error,
    touched,
    helperText,
    className = '',
    fieldClassName = '',
    ...props
  }) => (
    <FieldWrapper
      label={label}
      required={required}
      error={error}
      touched={touched}
      helperText={helperText}
      className={className}
    >
      <AntInput {...props} className={fieldClassName} status={getStatus(touched, error)} />
    </FieldWrapper>
  ),
);

Input.displayName = 'Input';

export const PasswordInput = memo(
  ({
    label,
    required,
    error,
    touched,
    helperText,
    className = '',
    fieldClassName = '',
    ...props
  }) => (
    <FieldWrapper
      label={label}
      required={required}
      error={error}
      touched={touched}
      helperText={helperText}
      className={className}
    >
      <AntInput.Password {...props} className={fieldClassName} status={getStatus(touched, error)} />
    </FieldWrapper>
  ),
);

PasswordInput.displayName = 'PasswordInput';

export const Textarea = memo(
  ({
    label,
    required,
    error,
    touched,
    helperText,
    className = '',
    fieldClassName = '',
    rows = 4,
    ...props
  }) => (
    <FieldWrapper
      label={label}
      required={required}
      error={error}
      touched={touched}
      helperText={helperText}
      className={className}
    >
      <AntInput.TextArea
        {...props}
        rows={rows}
        className={fieldClassName}
        status={getStatus(touched, error)}
      />
    </FieldWrapper>
  ),
);

Textarea.displayName = 'Textarea';

export default Input;
